<template>
  <div class="app-container">
    <CrudTable entity="Supplier" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';

export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        'name',
        { field: 'code', label: 'supplier.code' },
        { field: 'agentName', label: 'supplier.agentName' },
        { field: 'domainName', label: 'common.domain' },
        'phone',
        'email'
      ]
    };
  },
  methods: {
    generateSummary({ name }) {
      return `${name}`;
    }
  }
};
</script>
